import AboutModal from './AboutModal.json';
import AppearanceModal from './AppearanceModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DataTable from './DataTable.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import MeasurementTable from './MeasurementTable.json';
import DataRow from './DataRow.json';
import Modes from './Modes.json';
import SegmentationPanel from './SegmentationPanel.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import TooltipClipboard from './TooltipClipboard.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Messages from './Messages.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';
import CaptureViewportModal from './CaptureViewportModal.json';
import Hps from './Hps.json';
import ToolbarLayoutSelector from './ToolbarLayoutSelector.json';
import Tools from './Tools.json';
import Onboarding from './Onboarding.json';
import Colormaps from './Colormaps.json';
import PanelSUV from './PanelSUV.json';
import ROIThresholdConfiguration from './ROIThresholdConfiguration.json';
import USAnnotationPanel from './USAnnotationPanel.json';
import EncapsulatedDocument from './EncapsulatedDocument.json';

export default {
  'en-US': {
    AboutModal,
    AppearanceModal,
    Buttons,
    CineDialog,
    Common,
    DataSourceConfiguration,
    DataTable,
    DatePicker,
    ErrorBoundary,
    Header,
    HotkeysValidators,
    MeasurementTable,
    DataRow,
    Modes,
    SegmentationPanel,
    SidePanel,
    StudyBrowser,
    StudyItem,
    StudyList,
    TooltipClipboard,
    ThumbnailTracked,
    TrackedCornerstoneViewport,
    UserPreferencesModal,
    ViewportDownloadForm,
    Messages,
    WindowLevelActionMenu,
    CaptureViewportModal,
    Hps,
    ToolbarLayoutSelector,
    Tools,
    Onboarding,
    Colormaps,
    PanelSUV,
    ROIThresholdConfiguration,
    USAnnotationPanel,
    EncapsulatedDocument,
  },
};
